import type { ColDef, ICellRendererParams, ValueGetterParams } from 'ag-grid-community';

import type { Coefficient } from '@shared-types/coefficient.types';

const seasonalClubCols: ColDef[] = [
  {
    field: 'competition',
    headerName: 'competitions',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => (c.competition as any)?.displayName,
    cellClass: 'pk-justify-content--start',
    minWidth: 200,
  },
  {
    field: 'matches',
    headerName: 'matches',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.seasonRankings?.[0]?.numberOfMatches,
  },
];

export const seasonalClubMaleCols: ColDef[] = [
  ...seasonalClubCols,
  {
    field: 'points',
    headerName: 'points',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.seasonRankings?.at(0)?.totalPoints,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
  },
];

export const seasonalClubFemaleCols: ColDef[] = [
  ...seasonalClubCols,
  {
    field: 'tcc',
    headerName: 'points',
    headerTooltip: 'total_club_coefficient',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.seasonRankings?.at(0)?.totalPoints,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
  },
];

export const seasonalNationalCols: ColDef[] = [
  {
    field: 'clubs',
    headerName: 'clubs',
    headerTooltip: 'club_still_participating',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) =>
      (c.seasonRankings?.at(0)?.numberOfTeamsStillInPlaying ?? 0) / (c.seasonRankings?.at(0)?.numberOfTeams ?? 0),
    cellRenderer: ({ data: c }: ICellRendererParams<Coefficient>) =>
      [c.seasonRankings?.at(0)?.numberOfTeamsStillInPlaying, c.seasonRankings?.at(0)?.numberOfTeams]
        .filter(Boolean)
        .join('/'),
  },
  {
    field: 'bonus',
    headerName: 'bonus',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.seasonRankings?.at(0)?.factorTotalBonus,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
  },
  {
    field: 'points',
    headerName: 'points',
    headerTooltip: 'how_points_calculated',
    tooltipComponentParams: { openModal: true },
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.seasonRankings?.at(0)?.totalPointsWithBonus,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
  },
  {
    field: 'avg',
    headerName: 'average',
    valueGetter: ({ data: c }: ValueGetterParams<Coefficient>) => c.seasonRankings?.at(0)?.totalPoints,
    cellRenderer: ({ value }) => value?.toFixed(3) ?? '-',
  },
];
